import React from 'react'
import { cx } from '@/lib/utils'
import styles from './Avatar.module.scss'

type Size = 'sm' | 'md' | 'lg' | 'xl'

interface AvatarProps {
  src?: string | null
  alt: string
  size?: Size
}

const sizeMap: Record<Size, string> = {
  sm: styles.sizeSm, md: styles.sizeMd, lg: styles.sizeLg, xl: styles.sizeXl,
}

export const Avatar: React.FC<AvatarProps> = ({ src, alt, size = 'md' }) => (
  <div className={cx(styles.avatar, sizeMap[size])}>
    {src ? (
      <img src={src} alt={alt} className={styles.image} />
    ) : (
      <div className={styles.placeholder}>{alt.charAt(0).toUpperCase()}</div>
    )}
  </div>
)
